module.exports = __webpack_public_path__ + "assets/input_variant-07b8f3d00f98028332091e8f6870ec5d.png";